import React from 'react';
import { NavLink as RouterLink, useMatch, useResolvedPath } from 'react-router';

import styled from '@emotion/styled';

import FullRightTriangle from '../Icons/FullRightTriangle';

export const NavLink = styled(RouterLink)`
  text-decoration: none;
  color: black;
  font-weight: 500;
  display: flex;
  gap: 0.5rem;

  &.footer {
    font-weight: 600;
  }

  &.hamburger-menu {
    font-size: 1rem;
    font-weight: 600;
    color: black;
  }
`;

interface IExternalLink {
  children: React.ReactNode;
  to: string;
  className?: string;
}

export const ExternalLink: React.FC<IExternalLink> = ({
  children,
  to,
  className,
}) => {
  return (
    <AnchorTag
      href={to}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
    >
      {children}
    </AnchorTag>
  );
};

export const AnchorTag = styled.a`
  text-decoration: none;
  font-weight: 500;

  &.footer {
    display: grid;
    grid-template-columns: 1.5rem auto;
    gap: 0.5rem;
    font-weight: 600;
  }

  &.header_nav__mobile {
    @media (max-width: 480px) {
      display: None;
    }
  }
`;

export const ButtonLink = styled(RouterLink)`
  text-decoration: none;
  font-weight: 500;
`;

interface INavItem {
  icon: React.ReactNode;
  children: string;
  path: string;
  className?: string;
}

export const NavBoxItem: React.FC<INavItem> = ({
  icon,
  path,
  children,
  className,
}) => {
  const resolved = useResolvedPath(path);
  const match = useMatch({ path: resolved.pathname, end: false });
  const isActive = match !== null;

  return (
    <NavigationBoxLink
      className={`${className ?? ''} ${isActive ? 'active' : ''}`.trim()}
      to={path}
    >
      <div style={{ color: '#41415A' }}>{icon}</div>
      {children}
      <div className='v-line'></div>
    </NavigationBoxLink>
  );
};

export const MobileNavBoxItem: React.FC<INavItem> = ({
  icon,
  path,
  children,
  className,
}) => {
  const resolved = useResolvedPath(path);
  const match = useMatch({ path: resolved.pathname, end: false });
  const isActive = match !== null;

  return (
    <MobileNavigationBoxLink
      className={`${className ?? ''} ${isActive ? 'active' : ''}`.trim()}
      to={path}
    >
      <div style={{ color: '#41415A' }}>{icon}</div>
      {children}
      <FullRightTriangle />
    </MobileNavigationBoxLink>
  );
};

export const NavigationBoxLink = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: flex;
  gap: 7px;

  padding: 0px 24px;
  height: 36px;
  padding-right: 0px;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: white;

    &.active-grey {
      background-color: ${({ theme }) => theme.palette.lightGrayBg};
    }
  }

  &.active {
    background-color: white;

    &.active-grey {
      background-color: ${({ theme }) => theme.palette.lightGrayBg};
    }

    font-weight: 700;
    & svg {
      color: ${({ theme }) => theme.palette.logirateBlack};
    }

    & div.v-line {
      width: 4.17px;
      height: 100%;
      border-radius: 25px;

      background-color: ${({ theme }) => theme.palette.blueColor};
      margin-left: auto;
    }
  }
`;

export const InternalNavLink = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.navLinkColor};
  font-weight: 600;
  color: ${({ theme }) => theme.palette.navLinkColor};

  &:hover {
    color: #000000a7 !important;
  }

  &.footer {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.875rem;
    font-weight: 400;
  }

  &.hamburger {
    color: ${({ theme }) => theme.palette.navLinkColor};
    font-size: 1rem;
    font-weight: 600;
  }
`;

const MobileNavigationBoxLink = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: grid;
  grid-template-columns: 16px 1fr 16px;
  gap: 14px;
  border-radius: 8px;
  padding: 18px 24px;
  background-color: white;
  align-items: center;
`;
